import {Brick, registerBrick, BrickContext} from 'olympe';
import ReactDOM from 'react-dom';
import React from 'react';
import PropTypes from 'prop-types';
import {CandexContent} from './candex/CandexContent.jsx';

/**
 * A popup allowing the user to access Candex catalog
 */
export default class ShowCandexPopup extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} user
     * @param {string} candexTableData
     * @param {*} decryptPassword
     * @param {*} companyCodesAuthorized
     * @param {function()} forwardEvent
     * @param {function(string)} setURL
     * @param {function(string)} setCompanyCode
     */
    update($, [user, candexTableData, decryptPassword, companyCodesAuthorized], [forwardEvent, setURL, setCompanyCode]) {
        const popupId = 'popup019538b4996a84cb5ab2';
        if (!document.getElementById(popupId)) {
            const head = document.body;
            const popup = document.createElement('div');
            popup.id = popupId;
            head.appendChild(popup);
        }

        ReactDOM.render((<ShowCandexPopup.Component
            context={$}
            forwardEvent={forwardEvent}
            setURL={setURL}
            setCompanyCode={setCompanyCode}
            candexTableData={candexTableData}
            decryptPassword={decryptPassword}
            companyCodesAuthorized={companyCodesAuthorized}
        />), document.getElementById(popupId));
    }
}

ShowCandexPopup.Component = (props) => {
    return (
        <CandexContent {...props}/>
    );
};

ShowCandexPopup.Component.propTypes = {
    context: PropTypes.instanceOf(BrickContext).isRequired,
    forwardEvent: PropTypes.func,
    setURL: PropTypes.func,
    setCompanyCode: PropTypes.func,
    candexTableData: PropTypes.string,
    decryptPassword: PropTypes.object,
    companyCodesAuthorized: PropTypes.array,
};

registerBrick('019538b4996a84cb5ab2', ShowCandexPopup);
